export default () => ({

  loading: false,
  boards: {},
  subjects: [],
  activeSubjectIdx: 0,
  activeGroupKey: undefined,

  openCtas: 0,
  openReadMes: 0,
  total: 0,
  page: 1

})
